// import styles
import '../sass/index.scss'
// import dependencies
import $ from 'jquery' //! external, see webpack/webpack.common.js

// import bootstrap modules
import './utils/bootstrap'

// import local modules
import Navigation from './components/navigation'
import HeaderScroll from './components/header-scroll'
import Accordions from './components/accordion'
// import Videos from './components/video'
import Backlink from './components/backlink'
import NewsLists from './components/news-list'
import ScrollHelper from './utils/scroll-helper'
import HelpingHands from './components/helping-hands'
import MoodPoll from './components/moodpoll'
import InjectSvg from './components/inject-svg'
import Testimonials from './components/forms/testimonial'
import RegistrationForm from './components/forms/registration-form'
import FormValidation from './components/forms/form-validation'
import HelpingHandsRegistrationForm from './components/forms/helping-hands-registration-form'
import ActionForm from './components/forms/action-form'
import TextInputCounters from './components/forms/text-input-counter'
import Autocompletes from './components/forms/autocomplete'
import ArticleList from './components/article-list'
import MessageBar from './components/message-bar'
import Article from './components/article'
import TopicList from './components/topic-list'
import LoadMore from './components/load-more'
import FileInfo from './components/forms/file-info'
import NewsListSlider from './components/news-list-slider'
import TeaserSlider from './components/teaser-slider'
import ShareFunction from './components/share-function'
import SkipLinks from './components/skip-links'
import SearchOverlay from './components/search-overlay'
import SearchResults from './components/search-results'
import HeroSlider from './components/hero-slider'
import Introduction from './components/introduction'
import Tabs from './components/tabs'

// Wait for dom ready
$(() => {
  // init modules
  new Navigation()
  new HeaderScroll()
  new Accordions()
  // new Videos()
  new Backlink()
  new NewsLists()
  new HelpingHands()
  new MoodPoll()
  new SearchOverlay()
  new SearchResults()
  FileInfo.init()
  Tabs.init()

  // init forms
  new Testimonials()
  new RegistrationForm()
  new FormValidation()
  new HelpingHandsRegistrationForm()
  new ActionForm()
  new TextInputCounters()
  new Autocompletes()
  Introduction.init()

  // load svg's and inject them inline into dom
  new InjectSvg()

  // init article & topic lists
  // TODO: Refactor article classes to work with multiple lists!
  new ArticleList()
  new Article()
  new TopicList()
  new MessageBar()
  new NewsListSlider()
  new TeaserSlider()
  new HeroSlider()
  new ShareFunction()
  SkipLinks.init()
  LoadMore.init()

  // init scroll helper
  ScrollHelper.bindLocationHash()
})
